let current = {
    compile: function (template, _options) {
        return template;
    }
};
export class TemplateService {
    static register(userImplementation) {
        current = userImplementation;
    }
    static compile(template, options = {}) {
        return current.compile(template, options);
    }
}
